(function () {
  'use strict';

  const MOBILE_MEDIA_QUERY = '(max-width: 900px)';
  const MOBILE_CARD_IMAGE_CLASS = 'ezpo-mobile-ai-card-image';
  const MOBILE_PINK_SCROLL_HEIGHT_VH = 7.6;

  const AI_CARD_IMAGE_CONFIGS = [
    {
      imageSelector: 'img[alt="AI assistants recommending Easify products"]',
      desktopAssetKey: 'assets/card-ai-friendly.png',
      mobileAssetKey: 'assets/mobile-card-ai-friendly.png'
    },
    {
      imageSelector: 'img[alt="AI Readiness score panel"]',
      desktopAssetKey: 'assets/card-ai-ready.png',
      mobileAssetKey: 'assets/mobile-card-ai-ready.png'
    },
    {
      imageSelector: 'img[alt="Shopify Sidekick creating an option set"]',
      desktopAssetKey: 'assets/card-sidekick.png',
      mobileAssetKey: 'assets/mobile-card-sidekick.png'
    },
    {
      imageSelector: '.ezpo-ai-powered-demo__base',
      desktopAssetKey: 'assets/card-ai-powered.png',
      mobileAssetKey: 'assets/mobile-card-ai-powered.png',
      isAiPoweredDemo: true
    }
  ];

  const isMobileViewport = () => window.matchMedia(MOBILE_MEDIA_QUERY).matches;

  const rememberDesktopStyle = (element) => {
    if (!element || element.dataset.ezpoDesktopStyle) return;
    element.dataset.ezpoDesktopStyle = element.getAttribute('style') || '';
  };

  const applyImportantStyles = (element, styles) => {
    Object.entries(styles).forEach(([property, value]) => {
      element.style.setProperty(property, value, 'important');
    });
  };

  const setImageSource = (image, source) => {
    if (!source) return;
    if (image.getAttribute('src') !== source) {
      image.setAttribute('src', source);
    }
    image.removeAttribute('srcset');
  };

  const toggleMobileImageStyle = (image, isMobile) => {
    rememberDesktopStyle(image);
    image.classList.toggle(MOBILE_CARD_IMAGE_CLASS, isMobile);

    if (isMobile) {
      applyImportantStyles(image, {
        position: 'absolute',
        inset: '0',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        'max-width': 'none',
        transform: 'none',
        'object-fit': 'contain',
        'object-position': 'center'
      });
    } else {
      image.setAttribute('style', image.dataset.ezpoDesktopStyle || '');
    }
  };

  const getImageFrame = (image, config) => {
    if (config.isAiPoweredDemo) {
      return image.closest('.ezpo-ai-powered-demo')?.parentElement || null;
    }

    return image.parentElement;
  };

  const getAiCard = (image) => {
    return image.closest('#pinkGrid > div');
  };

  const getAiCardText = (image) => {
    const card = getAiCard(image);
    return card?.querySelector(':scope > div:last-child') || null;
  };

  const toggleMobileCardLayout = (image, isMobile) => {
    const card = getAiCard(image);
    const text = getAiCardText(image);
    [card, text].forEach(rememberDesktopStyle);

    if (isMobile) {
      if (card) {
        applyImportantStyles(card, {
          width: '100%',
          'max-width': '337px',
          margin: '0 auto',
          padding: '13px',
          gap: '6px',
          overflow: 'visible'
        });
      }

      if (text) {
        applyImportantStyles(text, {
          width: 'min(100%, 311px)',
          margin: '0 auto',
          padding: '0',
          'box-sizing': 'border-box'
        });
      }
    } else {
      restoreDesktopStyle(card);
      restoreDesktopStyle(text);
    }
  };

  const toggleMobileImageFrame = (image, config, isMobile) => {
    const frame = getImageFrame(image, config);
    if (!frame) return;
    rememberDesktopStyle(frame);

    if (isMobile) {
      frame.dataset.ezpoMobileAiCardFrame = '1';
      applyImportantStyles(frame, {
        flex: '0 0 auto',
        width: 'min(100%, 311px)',
        height: 'auto',
        'min-height': '0',
        'aspect-ratio': '311 / 200',
        margin: '0 auto',
        'border-radius': '6px'
      });
    } else {
      delete frame.dataset.ezpoMobileAiCardFrame;
      frame.setAttribute('style', frame.dataset.ezpoDesktopStyle || '');
    }
  };

  const toggleAiPoweredMobileState = (image, isMobile) => {
    const demo = image.closest('.ezpo-ai-powered-demo');
    const compare = demo?.querySelector('.ezpo-ai-compare');

    rememberDesktopStyle(demo);
    rememberDesktopStyle(compare);

    if (demo) {
      if (isMobile) {
        demo.dataset.ezpoMobileAiPowered = '1';
      } else {
        delete demo.dataset.ezpoMobileAiPowered;
        demo.setAttribute('style', demo.dataset.ezpoDesktopStyle || '');
      }
    }

    if (compare && !isMobile) {
      compare.setAttribute('style', compare.dataset.ezpoDesktopStyle || '');
    }
  };

  const restoreDesktopStyle = (element) => {
    if (!element?.dataset.ezpoDesktopStyle) return;
    element.setAttribute('style', element.dataset.ezpoDesktopStyle);
  };

  const restoreMobileAiOverrides = (section, assetMap) => {
    const pinkCard = section.querySelector('#pinkCard');
    const pinkInner = section.querySelector('#pinkInner');
    const pinkGrid = section.querySelector('#pinkGrid');
    const cardsWrap = section.querySelector('#cardsWrap') || section;
    const cardsStick = section.querySelector('#cardsStick');

    [cardsWrap, cardsStick, pinkCard, pinkInner, pinkGrid].forEach(restoreDesktopStyle);
    delete pinkCard?.dataset.ezpoMobileAiAutoHeight;
    delete section.dataset.ezpoMobileAiApplied;

    AI_CARD_IMAGE_CONFIGS.forEach((config) => {
      const image = section.querySelector(config.imageSelector);
      if (!image) return;

      setImageSource(image, assetMap?.[config.desktopAssetKey]);
      image.classList.remove(MOBILE_CARD_IMAGE_CLASS);
      restoreDesktopStyle(image);

      const frame = getImageFrame(image, config);
      if (frame) {
        delete frame.dataset.ezpoMobileAiCardFrame;
        restoreDesktopStyle(frame);
      }

      const card = getAiCard(image);
      const text = getAiCardText(image);
      restoreDesktopStyle(card);
      restoreDesktopStyle(text);

      if (config.isAiPoweredDemo) {
        const demo = image.closest('.ezpo-ai-powered-demo');
        const compare = demo?.querySelector('.ezpo-ai-compare');
        if (demo) {
          delete demo.dataset.ezpoMobileAiPowered;
          restoreDesktopStyle(demo);
        }
        restoreDesktopStyle(compare);
      }
    });
  };

  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const easeOutCubic = (value) => 1 - Math.pow(1 - clamp(value), 3);
  const easeInOutCubic = (value) => {
    const t = clamp(value);
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  };

  const getSectionProgress = (element) => {
    if (!element) return 0;
    const rect = element.getBoundingClientRect();
    const total = element.offsetHeight - window.innerHeight;
    if (total <= 0) return 0;
    return clamp(-rect.top / total);
  };

  const measurePinkCardHeight = (pinkCard, pinkInner) => {
    const cardStyle = window.getComputedStyle(pinkCard);
    const paddingY = parseFloat(cardStyle.paddingTop || 0) + parseFloat(cardStyle.paddingBottom || 0);
    return Math.ceil(pinkInner.scrollHeight + paddingY + 2);
  };

  const applyBaseMobileCardFrame = (section, progress) => {
    const stick = section.querySelector('#cardsStick');
    const slot = section.querySelector('#pinkSlot');
    const card = section.querySelector('#pinkCard');
    const gray = section.querySelector('#grayCard');
    const ask = section.querySelector('#askHead');
    const badge = section.querySelector('#pinkBadge');
    const para = section.querySelector('#pinkPara');
    const grid = section.querySelector('#pinkGrid');
    if (!stick || !slot || !card || !gray) return;

    const vh = window.innerHeight;
    const vw = window.innerWidth;
    const stickRect = stick.getBoundingClientRect();
    const slotRect = slot.getBoundingClientRect();
    const start = {
      left: slotRect.left - stickRect.left,
      top: slotRect.top - stickRect.top,
      width: slotRect.width,
      height: slotRect.height
    };
    const g = clamp((progress - 0.3) / 0.5);
    const e = easeInOutCubic(g);
    const er = easeOutCubic(clamp(progress / 0.08));
    const marginX = Math.max(16, vw * 0.014);
    const marginY = Math.max(16, vh * 0.02);
    const end = {
      left: marginX,
      top: marginY,
      width: vw - marginX * 2,
      height: vh - marginY * 2
    };
    const left = start.left + (end.left - start.left) * e;
    const top = start.top + (end.top - start.top) * e + (1 - er) * 110;
    const width = start.width + (end.width - start.width) * e;
    const height = start.height + (end.height - start.height) * e;

    applyImportantStyles(card, {
      position: 'absolute',
      left: `${left.toFixed(1)}px`,
      top: `${top.toFixed(1)}px`,
      right: 'auto',
      bottom: 'auto',
      width: `${width.toFixed(1)}px`,
      height: `${height.toFixed(1)}px`,
      'min-height': '0',
      opacity: er.toFixed(3),
      overflow: 'hidden',
      transform: 'none',
      'will-change': 'left, top, width, height'
    });

    applyImportantStyles(gray, {
      opacity: (((1 - clamp((g - 0.06) / 0.3)) * er).toFixed(3)),
      transform: `translateY(${((1 - er) * 110).toFixed(1)}px) translateX(${(-e * 26).toFixed(1)}vw)`
    });

    if (ask) {
      const askOpacity = 1 - clamp((g - 0.1) / 0.25);
      const lift = er * (vh * 0.5 - Math.max(56, vh * 0.11) - ask.offsetHeight / 2);
      applyImportantStyles(ask, {
        opacity: askOpacity.toFixed(3),
        transform: `translate(-50%, -50%) translateY(${(-lift).toFixed(1)}px)`
      });
    }

    if (badge) {
      applyImportantStyles(badge, { opacity: (1 - Math.min(1, e * 2.4)).toFixed(3) });
    }

    if (para) {
      applyImportantStyles(para, { opacity: (1 - clamp((g - 0.28) / 0.3)).toFixed(3) });
    }

    if (grid) {
      const gridIntro = clamp((g - 0.68) / 0.28);
      if (gridIntro <= 0) {
        applyImportantStyles(grid, {
          display: 'none',
          opacity: '0',
          height: '0',
          overflow: 'hidden',
          transform: 'translateY(60px)',
          'pointer-events': 'none'
        });
      }
    }
  };

  const applyMobilePinkCardAutoHeight = (section, isMobile) => {
    const pinkCard = section.querySelector('#pinkCard');
    const pinkInner = section.querySelector('#pinkInner');
    const pinkGrid = section.querySelector('#pinkGrid');
    const cardsWrap = section.querySelector('#cardsWrap') || section;
    const cardsStick = section.querySelector('#cardsStick');
    if (!pinkCard || !pinkInner || !pinkGrid) return;

    if (!isMobile) {
      return;
    }

    [cardsWrap, cardsStick, pinkCard, pinkInner, pinkGrid].forEach(rememberDesktopStyle);
    section.dataset.ezpoMobileAiApplied = '1';
    pinkCard.dataset.ezpoMobileAiAutoHeight = '1';

    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const sectionHeight = Math.ceil(viewportHeight * MOBILE_PINK_SCROLL_HEIGHT_VH);

    applyImportantStyles(cardsWrap, {
      height: `${sectionHeight}px`,
      'min-height': `${sectionHeight}px`,
      overflow: 'visible'
    });

    if (cardsStick) {
      applyImportantStyles(cardsStick, {
        position: 'sticky',
        top: '0',
        height: '100svh',
        overflow: 'hidden'
      });
    }

    const progress = getSectionProgress(cardsWrap);
    const zoom = clamp((progress - 0.3) / 0.5);
    const gridProgress = clamp((zoom - 0.62) / 0.32);
    const longProgress = clamp((progress - 0.78) / 0.16);

    applyBaseMobileCardFrame(section, progress);

    if (gridProgress <= 0) {
      applyImportantStyles(pinkInner, {
        height: '100%',
        display: 'flex',
        'flex-direction': 'column',
        'justify-content': 'space-between',
        transform: 'none',
        'will-change': 'auto'
      });
      return;
    }

    const marginX = Math.max(15, viewportWidth * 0.014);
    const marginY = Math.max(16, viewportHeight * 0.02);
    const baseHeight = viewportHeight - marginY * 2;
    const gridOpacity = easeOutCubic(gridProgress);

    applyImportantStyles(pinkGrid, {
      position: 'relative',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      width: '100%',
      height: 'auto',
      'max-height': 'none',
      display: 'grid',
      opacity: gridOpacity.toFixed(3),
      overflow: 'visible',
      'overflow-x': 'visible',
      'overflow-y': 'visible',
      'padding-bottom': '0',
      transform: `translateY(${((1 - gridOpacity) * 36).toFixed(1)}px)`,
      'pointer-events': gridOpacity > 0.98 ? 'auto' : 'none'
    });

    const targetHeight = Math.max(baseHeight, measurePinkCardHeight(pinkCard, pinkInner));
    const contentShift = Math.max(0, targetHeight - baseHeight) * easeInOutCubic(longProgress);

    applyImportantStyles(pinkInner, {
      height: 'auto',
      display: 'flex',
      'flex-direction': 'column',
      'justify-content': 'flex-start',
      gap: '10px',
      transform: `translateY(${-contentShift.toFixed(1)}px)`,
      'will-change': 'transform'
    });

    applyImportantStyles(pinkCard, {
      position: 'absolute',
      left: `${marginX.toFixed(1)}px`,
      top: `${marginY.toFixed(1)}px`,
      right: 'auto',
      bottom: 'auto',
      width: `${(viewportWidth - marginX * 2).toFixed(1)}px`,
      'max-width': 'none',
      height: `${baseHeight.toFixed(1)}px`,
      'min-height': `${baseHeight.toFixed(1)}px`,
      opacity: '1',
      overflow: 'hidden',
      'will-change': 'left, top, width, height',
      transform: 'none'
    });
  };

  const bindMobilePinkCardAutoHeightWatcher = (host, assetMap) => {
    if (host.dataset.ezpoMobileAiAutoHeightWatcher === '1') return;
    host.dataset.ezpoMobileAiAutoHeightWatcher = '1';

    let animationFrame = 0;
    const schedule = () => {
      const section = host.querySelector('[data-screen-label="Blind vs Understood"]');
      if (!isMobileViewport() && section?.dataset.ezpoMobileAiApplied !== '1') return;
      if (animationFrame) return;
      animationFrame = window.requestAnimationFrame(() => {
        animationFrame = 0;
        applyMobileAiCardImages(host, assetMap);
      });
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
  };

  const applyMobileAiCardImages = (host, assetMap) => {
    if (!host || !assetMap) return;

    const section = host.querySelector('[data-screen-label="Blind vs Understood"]');
    if (!section) return;

    const isMobile = window.matchMedia(MOBILE_MEDIA_QUERY).matches;

    if (!isMobile) {
      if (section.dataset.ezpoMobileAiApplied === '1') {
        restoreMobileAiOverrides(section, assetMap);
      }
      bindMobilePinkCardAutoHeightWatcher(host, assetMap);
      return;
    }

    AI_CARD_IMAGE_CONFIGS.forEach((config) => {
      const image = section.querySelector(config.imageSelector);
      if (!image) return;

      const nextAssetKey = isMobile ? config.mobileAssetKey : config.desktopAssetKey;
      const nextSource = assetMap[nextAssetKey];

      setImageSource(image, nextSource);
      toggleMobileImageStyle(image, isMobile);
      toggleMobileImageFrame(image, config, isMobile);
      toggleMobileCardLayout(image, isMobile);

      if (config.isAiPoweredDemo) {
        toggleAiPoweredMobileState(image, isMobile);
      }
    });

    applyMobilePinkCardAutoHeight(section, isMobile);
    bindMobilePinkCardAutoHeightWatcher(host, assetMap);
  };

  window.EzpoMobileAiCardImages = {
    apply: applyMobileAiCardImages
  };
})();
